export default __webpack_public_path__ + "static/media/redo-inactive.e33fa541.png";